import URI from 'urijs';
import config from 'Config/index';

function buildProposalUrl({
  productId,
  proposalId,
  currentUri,
  fromSearches,
}: {
  productId: string;
  proposalId: string;
  currentUri: string;
  fromSearches: boolean;
}): string | null | undefined {
  const redirectionQueryParameters = {
    proposalIds: proposalId,
    selectedProposalId: proposalId,
    product: productId,
    coderesort: productId,
    fromSearches,
  };
  const uri = new URI(currentUri);
  const queryParams = URI.parseQuery(uri.search());

  if (queryParams.locale) {
    // @ts-expect-error TODO(flow-migration)
    redirectionQueryParameters.locale = queryParams.locale;
  }

  return uri
    .segment([config.get('booking.endpoints.responsive')])
    .query(redirectionQueryParameters)
    .toString();
}

function buildUrlFromContextNumber(
  formData: any,
  appContext: AppContext,
  currentUri: string,
): string | null | undefined {
  return buildProposalUrl({
    appContext,
    productId: formData.resortId,
    proposalId: formData.reference,
    fromSearches: formData.fromSearches,
    currentUri,
  });
}

export { buildProposalUrl, buildUrlFromContextNumber };
